import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'
import { FormField } from 'rmwc/FormField';
import { ListDivider , ListItemGraphic} from 'rmwc/List';
import {default as Reactsel} from 'react-select';
import StarRatings from 'react-star-ratings';
import ResourceComponent from '../learning_resource_admin/ResourceComponent';
import ReactGA from 'react-ga';

class UserResourcePage extends Component {
	constructor(props) {
    	super(props)
    	this.state = {
            loadingState: true,
    		data:{
    			standardDetails: [],
    			resourceDetails: []
    		},
            standardsView: false
    	}
    }

    handleBackAction = (e) => {
        e.preventDefault()
        if (this.props.match.params.view === 'false'){
            this.props.history.push(`/portal/app/user/learning_resources`)
        }
        else if (this.props.match.params.view === 'true') {
            this.props.history.push(`/portal/app/user/my_learning_path/my_strength_and_development_areas`)
        }
    }

    handleStandardsView = (e) => {
        if (this.state.standardsView === false){
            this.setState({standardsView: true})
        }
        else {
            this.setState({standardsView: false})
        }
    }

    handleResourceFetch = (e) => {
    }

    componentDidMount() {
    	let data = Object.assign({}, this.state.data)

        ReactGA.set({ userId: this.props.user.id });
        ReactGA.initialize('UA-139837993-1');
        ReactGA.pageview(`/user_resource_page/${this.props.match.params.typeName}`);

    	let fetchStandards = `user/learning_resource/aspects/standards/${this.props.match.params.type}`
    	let fetchResources = `user/learning_resource/resources/${this.props.match.params.type}
    	`
    	return api.getUserResponse(this.props.user.accessToken, fetchStandards)
		.then((result) => {
			if (result.status === 'success'){
				data.standardDetails = result.data
				api.getUserResponse(this.props.user.accessToken, fetchResources)
				.then((result) => {
					if (result.status === 'success'){
						data.resourceDetails = result.data
						this.setState({data: data, loadingState: false})
					}
				})
			}
		})
    }

    render() {
    	let handleBackAction = this.handleBackAction
        let handleResourceFetch = this.handleResourceFetch
        let handleStandardsView = this.handleStandardsView
    	let parentStandards, individualResource, associatedStandards

        if (this.state.loadingState === true) {
            individualResource = (
                <div className="loader-component">
                    <div className="loader"></div>
                </div>
            )
        }
        else {
        	if (this.state.data.resourceDetails.length > 0) {
                individualResource = (
                    <Grid className="opportunity-list-item">
                        {this.state.data.resourceDetails.map(function(resource){
                            return (
                                <GridCell span = "12" key = {resource.id}>
                                    <Card style={{padding: '0px'}}>
                                        <ResourceComponent resourceId = {resource.id}
                                            resourceName = {resource.name}
                                            resourceAuthor = {resource.author}
                                            resourceDescription = {resource.description}
                                            shortDescription = {resource.short_description}
                                            resourceLink = {resource.resource_link}
                                            resourceLanguage = {resource.language}
                                            languageId = {resource.language_id}
                                            resourceComplexity = {resource.complexity}
                                            complexityId = {resource.complexity_id}
                                            parentTags = {resource.parent_tags}
                                            resourceStatus = {resource.active}
                                            resourceType = {resource.resource_type}
                                            imageLink = {resource.img_link}
                                            onHandleResourceFetch = {handleResourceFetch}
                                            isAdmin = {false}
                                            bookmarkFeature = {true} 
                                            archiveFeature = {false}
                                        />
                                    </Card>
                                </GridCell>
                            )
                        })}
                    </Grid>
                )
            }
            else {
                individualResource = (
                    <Grid className="opportunity-list-item">
                        <GridCell span = "12">
                            <Card style={{padding: '25px'}}>
                                <Typography>Resources will be made available in the coming days.</Typography>
                            </Card>
                        </GridCell>
                    </Grid>
                )
            }
        }

        if (this.state.standardsView === true) {
            associatedStandards = (
                <div>
                    <ul>
                        {this.state.data.standardDetails.map(function(standard){
                            return (
                                <Typography use="captions"><li><i>{standard.tag}</i> - {standard.name}</li></Typography>
                            )
                        })}
                    </ul>
                </div>
            )
        }

    	if (this.state.data.standardDetails.length > 0) {
			parentStandards = (
				<div>
					<Grid className="opportunity-list-item">
						<GridCell span = "8">
							<Typography use="headline7">To view the CENTA Standards under this Aspect,</Typography>
                            <Typography className = "typography_link" use="headline7" onClick={((e) => handleStandardsView(e))}> <a style={{cursor: 'pointer'}}><u>Click here</u></a></Typography>
						</GridCell>
                        <GridCell span = "8">
                            {associatedStandards}
                        </GridCell>
					</Grid>
				</div>
			)
		}

    	return(
    		<div>
				<Grid className="opportunity-list-item">
					<GridCell span = "12">
						<Card style={{padding: '0px'}}>
							<Grid>
								<GridCell span = "11">
	                            	<Typography use="headline5">{this.props.match.params.typeName}</Typography>
	                            </GridCell>
                                <GridCell span = "1">
                                    <Button raised style={{ width: '100%' }} onClick={((e) => handleBackAction(e))}>Back</Button>
                                </GridCell>
	                       	</Grid>
                        </Card>
					</GridCell>
				</Grid>
				{parentStandards}
				{individualResource}
			</div>
    	)
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserResourcePage);


// WEBPACK FOOTER //
// ./src/views/learning_resource_user/UserResourcePage.jsx